import { useIntakeManagementPageProps } from '~/data';
import { IntakeManagementLayout } from './layouts';
import { LoadingPage } from '~/pages/LoadingPage';
import { ErrorPage, ErrorHandler } from '~/pages/ErrorPage';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';
import { IntakeManagementProvider } from './context/IntakeManagementContext';

export function IntakeManagementPage() {
  useWindowDocumentTitle('Intake Management');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } =
    useIntakeManagementPageProps();

  if (!isInitialPropsError && isLoadingInitialProps) {
    return <LoadingPage />;
  }
  if (isInitialPropsError) {
    return <ErrorHandler error={initialPropsError} />;
  }
  if (!initialProps) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return (
    <IntakeManagementProvider initialProps={initialProps}>
      <IntakeManagementLayout />
    </IntakeManagementProvider>
  );
}
